import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleInfo } from "@fortawesome/sharp-solid-svg-icons";
import React from "react";

interface BuiltYearDetailsProps {
  label: string;
  yearBuilt: number;
  yearRenovationAddition: number;
  info?: string;
}

const BuiltYearDetails: React.FC<BuiltYearDetailsProps> = ({ label, yearBuilt, yearRenovationAddition, info }) => {
  return (
    <div className="flex justify-between">
      <div className="flex items-center gap-1  homepage-text-sm ">
        <span>{label}</span>
        {info && (
          <FontAwesomeIcon
            className="size-3.5 text-gray-400"
            icon={faCircleInfo}
          />
        )}
      </div>
      <div className="homepage-text-sm ">
        <p>{yearBuilt}{yearRenovationAddition ? ` / ${yearRenovationAddition}` : ''}</p>
      </div>
    </div>
  );
};

export default BuiltYearDetails;
